import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
    hasExtendLimits(data) {
        return zwitCore.HTTP.post(
            BASE_URL + "/zw-user/promoterInfos/checkUserHasPromoterPermiss",
            data,
            false,
        );
    },
    signStatus(data) {
        return zwitCore.HTTP.post(
            BASE_URL + "/zw-user/promoterInfos/checkUserIsFinishSelfContract",
            data,
            false,
        );
    },
    OpenExtendPermission(data) {
        return zwitCore.HTTP.post(
            BASE_URL + "/zw-user/promoterInfos/registeredPromoter",
            data,
            false,
        );
    },
    getExtendMyList(data) {
        return zwitCore.HTTP.postJsonData(
            BASE_URL + "/zw-user/promoterInfos/getPromoterGoodsRespDTO",
            data,
            false,
        );
    },
    getExtendDetail(data) {
        return zwitCore.HTTP.postJsonData(
            BASE_URL + "/zw-order/promoterTradeRecode/nf/selectPromoterTradeRecodeList",
            data,
            false,
        );
    },
    getExtendMarketList(data) {
        return zwitCore.HTTP.postJsonData(
            BASE_URL + "/zw-user/promoterInfos/getPromoterMarket",
            data,
            false,
        );
    },
    setExtendInfo(data) {
        return zwitCore.HTTP.post(
            BASE_URL + "/zw-user/promoterInfos/insertPromoteGoods",
            data,
            false,
        );
    },
    getExtendAgreement(data) {
        return zwitCore.HTTP.post(BASE_URL + "/zw-user/nf/promoterTermsOfUse", data, false);
    },
};
